import React from 'react';
import { CheckIcon, MinusIcon } from 'lucide-react';
import { forYou, notForYou } from '../data/landing';
export function AudienceSection() {
  return <section className="bg-ink" data-id="element-14" data-mp="n3kzd69k78e5">
      <div className="mx-auto max-w-6xl px-5 py-10 md:px-6 md:py-16 lg:py-20" data-id="element-15" data-mp="s0um2e5kd5ya">
        <h2 className="font-display text-xl text-cream md:text-3xl lg:text-4xl" data-id="element-16" data-mp="ryrtbmd10ypv">
          ¿Este libro es para ti?
        </h2>

        <div className="mt-5 grid gap-6 md:mt-10 lg:grid-cols-[1.3fr_1fr] lg:gap-16" data-id="element-17" data-mp="3vhthfkegggs2">
          <div data-id="element-18" data-mp="4aqr0v6fyeiw">
            <h3 className="font-serif text-lg text-gold-light md:text-2xl" data-id="element-19" data-mp="4a8ppk4x9a44">Es para ti si:</h3>
            <ul className="mt-3 space-y-2.5 md:mt-4 md:space-y-4" data-id="element-20" data-mp="99ldc73mal7r">
              {forYou.map(item => <li key={item} className="flex items-start gap-3 text-sm leading-relaxed text-cream md:text-lg" data-id="element-21" data-mp="e13eav5n4lsq">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-gold/60 md:mt-1 md:h-6 md:w-6" data-id="element-22" data-mp="3hpwv5wzgx13l">
                    <CheckIcon aria-hidden="true" className="h-3 w-3 text-gold md:h-3.5 md:w-3.5" data-id="element-23" data-mp="149hmm60jes5n" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="border-t border-line pt-5 lg:border-l lg:border-t-0 lg:pl-14 lg:pt-0" data-id="element-24" data-mp="uj6hwh914exp">
            <h3 className="font-serif text-lg text-muted md:text-2xl" data-id="element-25" data-mp="qj5rrzckifat">Quizás no sea para ti si:</h3>
            <ul className="mt-3 space-y-2.5 md:mt-4 md:space-y-4" data-id="element-26" data-mp="llmdizfve2iv">
              {notForYou.map(item => <li key={item} className="flex items-start gap-3 text-sm leading-relaxed text-muted md:text-base" data-id="element-27" data-mp="gnazsdmgf7vd">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-line md:h-6 md:w-6" data-id="element-28" data-mp="7luzwzt9mo5e">
                    <MinusIcon aria-hidden="true" className="h-3 w-3 text-muted md:h-3.5 md:w-3.5" data-id="element-29" data-mp="21yky3tqo2jil" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mt-6 max-w-2xl border-t border-line pt-4 font-serif text-base italic leading-relaxed text-cream/85 md:mt-12 md:pt-6 md:text-xl" data-id="element-30" data-mp="42vy2no79nxb">
          Este libro está pensado para lectores curiosos, dispuestos a dedicar
          tiempo a comprender y cuestionar ideas.
        </p>
      </div>
    </section>;
}